// CV Creator Configuration Constants
export const CV_CONFIG = {
  // Auto-save settings for non-authenticated users
  autoSave: {
    interval: 3000, // 3 seconds
    expiryTime: 10 * 60 * 1000, // 10 minutes
    storageKey: 'cv-tool.com_autosave'
  },
  
  // PDF generation settings
  pdf: {
    margin: [10, 10, 10, 10],
    format: 'A4',
    orientation: 'portrait',
    quality: 0.95,
    scale: 3,
    pageWidth: '8.5in'
  },
  
  // UI timing settings
  ui: {
    debounceDelay: 300, // milliseconds
    messageTimeout: 5000, // 5 seconds
    componentRenderDelay: 200, // milliseconds
    highlightDuration: 2000 // 2 seconds
  },
  
  // API endpoints
  api: {
    cvs: '/api/cvs',
    generatePdf: '/api/cvs/generate_pdf',
    saveDraft: '/api/cv/save_draft',
    optimizeBullets: '/api/cv_optimizer/bullets'
  },

  // Content validation
  validation: {
    // Bullets longer than this wrap to a second line in the PDF template
    maxBulletChars: 100
  },

  // CV parser upload limits (must match CvParserGuard on the backend)
  cvParser: {
    maxFileSizeBytes: 5 * 1024 * 1024,
    maxFileSizeLabel: '5 MB',
    maxPages: 5
  }
}

// Returns an error message when the file fails client-side CV parser checks.
export const validateCvParserFile = (file) => {
  if (!file) return 'Please choose a file to upload.'

  const { maxFileSizeBytes, maxFileSizeLabel } = CV_CONFIG.cvParser
  if (file.size > maxFileSizeBytes) {
    return `File is too large. Maximum size is ${maxFileSizeLabel}.`
  }

  if (file.size === 0) return 'File is empty.'

  const allowedExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif', '.txt']
  const extension = file.name.includes('.') ? `.${file.name.split('.').pop().toLowerCase()}` : ''
  if (!allowedExtensions.includes(extension)) {
    return 'Unsupported file type. Use PDF, Word, images, or text files.'
  }

  return null
}

// Prefer the server-provided user message; never surface raw provider errors.
export const parseCvParserError = (res, data) => {
  if (data?.message) return data.message

  switch (res?.status) {
    case 413:
      return 'This file is too large. Maximum size is 5 MB.'
    case 415:
      return 'This file type isn\'t supported. Please upload a PDF, Word document, or image of your CV.'
    case 429:
      return 'You\'ve uploaded too many CVs recently. Please wait an hour and try again.'
    default:
      return 'We couldn\'t read this CV. Please try a different file.'
  }
}

// Helper function to get CSRF token
export const getCSRFToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

// Helper function to create API headers
export const createApiHeaders = (additionalHeaders = {}) => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-CSRF-Token': getCSRFToken(),
  ...additionalHeaders
})